import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-admin-isues',
  templateUrl: './choose-admin-isues.component.html',
  styleUrls: ['./choose-admin-isues.component.css']
})
export class ChooseAdminIsuesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
